<template>
    <div class="message_wrap" ref="messageWrap" v-loading="loading">
        <div class="messgae_tab">
            <ul>
                <li
                    v-for="item in tabList"
                    :key="item.state"
                    :class="{ disabled: item.state == 'disturb', active: item.state == tabActive }"
                    @click="handleClickTab(item)"
                >
                    <i :class="['iconfont', item.icon]"></i>
                    <span>{{ item.name }}</span>
                    <span>{{
                        item.state == "disturb"
                            ? item.disturb_unread_count > 99
                                ? "99+"
                                : item.disturb_unread_count
                            : item.total_unread > 99
                            ? "99+"
                            : item.total_unread
                    }}</span>
                </li>
            </ul>
        </div>
        <div class="message_list">
            <p class="message_list_title">{{ tabActiveTitle }}</p>
            <div class="message_list_content">
                <ul>
                    <li
                        v-for="item in groupListContent"
                        :key="item.type"
                        class="message_list_item"
                        :class="{
                            message_list_item_notDisturb: item.state == 'disturb',
                            active: item.category_name_en == category_name_en,
                        }"
                        @click="handleClickGroupList(item)"
                    >
                        <div class="message_list_item_icon">
                            <img :src="item.icon_url" alt="" />
                            <!-- 有未读的优先展示未读的数，没有再展示免打扰的数 -->
                            <i
                                class="count"
                                :class="{ count_notDisturb: !item.unread_count && item.disturb_unread_count > 0 }"
                                v-if="item.unread_count > 0 || item.disturb_unread_count > 0"
                                >{{
                                    item.unread_count
                                        ? item.unread_count > 99
                                            ? "99+"
                                            : item.unread_count
                                        : item.disturb_unread_count > 99
                                        ? "99+"
                                        : item.disturb_unread_count
                                }}</i
                            >
                        </div>
                        <div class="message_list_item_content">
                            <p>
                                <span>{{ item.category_name }}</span
                                ><span>{{ item.last_message_time_show }}</span>
                            </p>
                            <p>
                                <span class="ellipsis">{{ item.last_message_title }}</span
                                ><i class="iconfont icon-message-notification" v-if="(!item.unread_count && item.disturb_unread_count > 0)  || tabActive == 'disturb'"></i>
                            </p>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="message_detail">
            <!-- <van-pull-refresh @refresh="onPullRefreshList" success-text="" v-model="pullLoading">
                        <van-list
                            :finished="finishedList"
                            @load="onLoadList"
                            finished-text="——已经到底了——"
                            v-model="listLoading"
                        > -->
            <!-- msg_notice_type: 0: 默认值或未定义,1: 仅通知，无需查看详情,2: 通知 + 点击详情跳转,3: 通知 + 点击详情跳转 + 操作 -->
            <ul class="message_detail_wrap" ref="scrollContainer" id="message_detail_wrap" @scroll="handleScroll">
                <li
                    class="list_item_detail"
                    :class="
                        item.msg_notice_type == 2 || item.msg_notice_type == 3
                            ? 'list_item_bg_blue'
                            : 'list_item_bg_green'
                    "
                    v-for="item in messageList"
                    :key="item.id"
                    :data-id="item.id"
                    :id="item.id"
                >
                    <p class="list_item_detail_time">{{ item.push_time_show || "未知时间" }}</p>
                    <div class="list_item_detail_content">
                        <div class="list_item_detail_icon">
                            <img :src="item.icon_url || category_icon" alt="" />
                        </div>
                        <div class="list_item_detail_right">
                            <div class="list_item_detail_content_title">
                                <div>
                                    <el-tooltip
                                        popper-class="tooltip_text"
                                        effect="dark"
                                        content="已完成"
                                        placement="top"
                                        v-if="!item.checked && item.status == 'later'"
                                    >
                                        <el-checkbox
                                            v-model="item.checked"
                                            @change="handleClickOperator('complete', item)"
                                        ></el-checkbox>
                                    </el-tooltip>
                                    <span>{{ item.title }}</span>
                                </div>
                                <el-dropdown placement="bottom-end" trigger="click">
                                    <i class="iconfont el-icon-more"></i>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item
                                            @click.native="handleClickOperator('disturb', item)"
                                            v-if="!item.is_closed"
                                        >
                                            此类消息免打扰
                                        </el-dropdown-item>
                                        <el-dropdown-item
                                            @click.native="handleClickOperator('open', item)"
                                            v-if="item.is_closed"
                                        >
                                            此类消息继续推送
                                        </el-dropdown-item>
                                        <el-dropdown-item
                                            v-if="
                                                (item.status == 'unread' || item.status == 'read') &&
                                                item.msg_notice_type == 3
                                            "
                                            @click.native="handleClickOperator('later', item)"
                                        >
                                            稍后处理
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                            <div class="list_item_detail_content_bottom">
                                <div v-if="item.content && item.content.content">
                                    <!-- <el-tooltip
                                        popper-class="tooltip_text"
                                        effect="dark"
                                        :content="item.content"
                                        placement="top-start"
                                        > -->
                                        <p class="ellipsis_text ellipsis_3"><span>{{ item.content && item.content.content}}</span><span v-if="item.link" class="link_icon" @click="handleClickToLink(item)"
                                            >查看详情
                                            <img
                                                src="https://download.hecoos.com/enlightv/2024-45/d773cf7f7e8c2899137cf875c60da210.png"
                                                alt=""
                                        /></span></p>
                                    <!-- </el-tooltip> -->
                                </div>
                                <div class="" v-if="item.content && item.content.overview_fields && item.content.overview_fields.length">
                                    <p v-for="(field,fieldIndex) in item.content.overview_fields" :key="fieldIndex" :class="{'ellipsis_text': fieldIndex === item.content.overview_fields.length - 1}">
                                        <template v-if="fieldIndex === item.content.overview_fields.length - 1">
                                            <span class="ellipsis">{{ field.field_name }}：{{ field.field_value }}</span><span v-if="item.link" class="link_icon" @click="handleClickToLink(item)"
                                            >查看详情
                                            <img
                                                src="https://download.hecoos.com/enlightv/2024-45/d773cf7f7e8c2899137cf875c60da210.png"
                                                alt=""
                                        /></span>
                                        </template>
                                        <template v-else>
                                            {{ field.field_name }}：{{ field.field_value }}
                                        </template>
                                    </p>
                                </div>
                                <div v-if="item.extend && item.extend.type == 'inviteUserEditToUser'">
                                    <el-button type="primary" size="small" plain v-if="item.extend.button_status" @click="handleClickProfile"
                                        >去完善</el-button
                                    >
                                    <el-button size="small" disabled plain v-if="!item.extend.button_status">已完善</el-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            
            <!-- </van-list>
            </van-pull-refresh> -->
            <div
                class="new_count_box cursor"
                v-if="messageListCount > 0 && tabActive == 'unread'"
                @click="handleClickToTop"
            >
                <img src="https://download.hecoos.com/enlightv/2024-45/5dcd224158f9ca176d74045d01d456e8.png" alt="" />
                <span>{{ messageListCount > 99 ? "99+" : messageListCount }}条新消息</span>
            </div>
        </div>
        <editMember
            v-if="editMemberDialogVisible"
            ref="editMember"
            :editMemberDialogVisible.sync="editMemberDialogVisible"
            :user_id="userInfo.user.id"
            :profile_edit="true"
            @success-callback="initData"
        />
    </div>
</template>
<script>
import {
    MessageGroupCounts,
    CategoryMessages,
    MessageBatchMarkRead,
    MessageBatchMarkLater,
    MessageBatchMarkComplete,
    MessageSettingSwitch,
} from "@/api";
import editMember from "../Department/department_personnel/component/member_edit.vue";
import { mapState } from "vuex";
import { routes } from "@/router";

export default {
    name: "Message",
    components: { editMember },
    data() {
        return {
            routes,
            loading: false,
            tabActive: "all",
            tabActiveTitle: "全部",
            tabList: [
                {
                    state: "all",
                    name: "全部",
                    icon: "icon-message-all",
                    total_unread: 0,
                    data: [],
                },
                {
                    state: "unread",
                    name: "未读",
                    icon: "icon-message-weidu",
                    total_unread: 0,
                    data: [],
                },
                {
                    state: "disturb",
                    name: "免打扰",
                    icon: "icon-message-notification",
                    total_unread: 0,
                    disturb_unread_count: 0,
                    data: [],
                },
                {
                    state: "later",
                    name: "稍后处理",
                    icon: "icon-messgae-clock",
                    total_unread: 0,
                    data: [],
                },
            ],
            // 分组
            listLoading: false,
            category_name_en: "",
            category_icon: "",
            groupListContent: [],
            // 消息列表
            messageListLoading: false,
            start_id: "",
            end_id: "",
            orderType: "desc",
            pullLoading: false,
            pullFinishedList: false, // 主要处理是否还可以下拉
            finishedList: false, // 主要处理是否还可以上拉加载
            messageList: [],
            messageListCount: 0,
            scrollIconMinId: "", // 最小ID，用于页面跳转到最顶部的时候使用

            orderIcon: "https://download.hecoos.com/enlightv/2024-49/a5aef7a899d3dc38199018c3339ab005.png",
            personnelIcon: "https://download.hecoos.com/enlightv/2024-49/c7d7b988cc4553663e533998f1a190fb.png",
            productIcon: "https://download.hecoos.com/enlightv/2024-49/2352388744b54470c15be9c8fec9f301.png",
            logIcon: "https://download.hecoos.com/enlightv/2024-49/8e3d4e047b8ad0672302811d12f332ef.png",
            approvalIcon: "https://download.hecoos.com/enlightv/2024-49/ba6aea1e12afc36610a6dff96e1eae92.png",
            customerIcon: "https://download.hecoos.com/enlightv/2024-49/3b889816afbb59992421607adcfadc18.png",
            workIcon: "https://download.hecoos.com/enlightv/2024-49/44a5c31125d52cbc8170a73f4a4d5b77.png",
            financeIcon: "https://download.hecoos.com/enlightv/2024-49/b74b39b1a6f1b2bce44214df70158abd.png",
            confirmMemberDialogVisible: false,
            confirmMemberType: "",
            editMemberDialogVisible: false,

            lastScrollTop: 0,
        };
    },
    computed: {
        ...mapState(["userInfo"]),
    },
    created() {
        this.getMessageGroupCounts();
    },
    mounted() {
        this.lastScrollTop = this.$refs.scrollContainer.scrollTop;
    },
    methods: {
        // js监听页面滚动
        handleScroll() {
            const currentScrollTop = event.target.scrollTop;
            const container = this.$refs.scrollContainer;

            // 判断滚动位置
            if (currentScrollTop === 0) {
                // console.log("到最顶部了");
                this.onPullRefreshList();
            }
            // 判断是否滚动到底部（误差 1px 防止计算误差）
            const isBottom = container.scrollHeight - container.scrollTop <= container.clientHeight + 1;
            if (isBottom) {
                // console.log("到最底部了");
                this.onLoadList();
            }
        },
        // 初始化列表滚动到最底部
        initContainerToBottom() {
            this.$nextTick(() => {
                let scrollableElement = document.querySelector(".message_detail_wrap");
                scrollableElement.scrollTop = scrollableElement.scrollHeight - scrollableElement.clientHeight;

                setTimeout(() => {
                    const elementArray = document.querySelector(".message_detail_wrap").children;
                    this.createIntersectionObserver(elementArray, this.changeCheck);
                }, 400);
            });
        },
        //监听元素是否进入可视区域
        createIntersectionObserver(elementArray, callback) {
            // 创建JS交叉观察函数
            const container = document.querySelector(".message_detail_wrap");

            // 创建IntersectionObserver实例，并指定根元素为container
            const options = {
                root: container, // 指定根元素为container
                rootMargin: "0px", // 根元素的外边距，这里设置为0px
                threshold: 0.5, // 交叉比例的阈值，这里设置为0.5，即目标元素50%可见时触发回调
            };

            this.observer = new IntersectionObserver((mutaions) => {
                // 创建IntersectionObserver对象 出现在视口里了
                mutaions.forEach((entry) => {
                    if (entry.isIntersecting) {
                        callback(entry.target.id);
                    }
                });
                if (mutaions[0].isIntersecting) {
                    // 传入参数并调用回调函数
                    callback(mutaions[0].target.id);
                }
            }, options);
            for (let i = 0; i < elementArray.length; i++) {
                // 需要监听的元素
                this.observer.observe(elementArray[i]);
            }
        },
        // 监听区域页面，变为已读
        changeCheck(id) {
            let res = this.messageList.filter((p) => p.id == id)?.[0] || null;
            if (res && res.status == "unread") {
                // console.log(res, 'res====')
                // 手动改为已读, 不刷新列表
                this.$set(res, "status", "read");
                this.setMessageBatchMarkRead([res.id]);
                // this.messageListCount--;
            }
        },
        // 消息图标跳转到最顶端
        handleClickToTop() {
            if (this.scrollIconMinId == this.messageList[0].id) {
                // 当前的列表已包含所有的未读数据，不需要去请求接口了
                let scrollableElement = document.querySelector(".message_detail_wrap");
                scrollableElement.scrollTop = 0;
                this.$nextTick(() => {
                    this.messageListCount = 0;
                });
            } else {
                // 去拿更多的没有读取的未读消息
                this.start_id = this.scrollIconMinId;
                this.end_id = "";
                this.orderType = "desc";
                this.getCategoryMessages();
            }
        },
        // 消息状态切换
        handleClickTab({ state, name, data }) {
            this.tabActive = state;
            this.tabActiveTitle = name;
            this.groupListContent = data || [];
            this.category_name_en = data[0]?.category_name_en || "";
            this.category_icon = data[0]?.icon_url || "";
            this.initCategoryMessages();
        },
        // 分组切换
        handleClickGroupList(item) {
            this.category_name_en = item.category_name_en || "";
            this.category_icon = item.icon_url || "";
            this.initCategoryMessages();
        },
        handleClickOperator(type, item) {
            switch (type) {
                case "disturb":
                    this.handleSwitchChange(item);
                    break;
                case "later":
                    this.setMessageBatchMarkLater([item.id]);
                    break;
                case "open":
                    this.handleSwitchChange(item);
                    break;
                case "complete":
                    this.setMessageBatchMarkComplete([item.id]);
                    break;
            }
        },
        // 完善信息
        handleClickProfile() {
            // this.confirmMemberDialogVisible = true
            this.editMemberDialogVisible = true;
        },
        // 完善信息完成
        initData() {
            this.editMemberDialogVisible = false;
            this.initCategoryMessages();
        },
        // 标记消息已读
        setMessageBatchMarkRead(ids) {
            const params = {
                message_record_user_ids: ids,
            };
            MessageBatchMarkRead(params).then((res) => {
                if (res.code === 200) {
                    // this.initCategoryMessages()
                    this.updateMessageGroupCounts()
                }
            });
        },
        // 标记消息稍后处理
        setMessageBatchMarkLater(ids) {
            const params = {
                message_record_user_ids: ids,
            };
            MessageBatchMarkLater(params).then((res) => {
                if (res.code === 200) {
                    this.$message.success("已添加至稍后处理分组");
                    this.initCategoryMessages();
                    this.updateMessageGroupCounts()
                }
            });
        },
        // 标记消息已完成
        setMessageBatchMarkComplete(ids) {
            const params = {
                message_record_user_ids: ids,
            };
            MessageBatchMarkComplete(params).then((res) => {
                if (res.code === 200) {
                    this.$message.success("已完成");
                    this.initCategoryMessages();
                    this.updateMessageGroupCounts()
                }
            });
        },
        // 标记消息模版开启关闭免打扰
        handleSwitchChange(item) {
            const params = {
                template_id: item.template_id,
                status: !item.is_closed, //是否开启免打扰 开启true 关闭false
            };
            MessageSettingSwitch(params).then((res) => {
                if (res.code === 200) {
                    if (item.is_closed) {
                        this.$message.success("消息提醒已开启");
                    } else {
                        this.$message.success("已移入免打扰分组");
                    }
                    this.initCategoryMessages()
                    this.updateMessageGroupCounts()
                }
            });
        },
        // 获取消息左侧分组和未读数
        getMessageGroupCounts() {
            this.loading = true;
            MessageGroupCounts()
                .then((res) => {
                    if (res.code === 200) {
                        const data = res.data;
                        this.tabList[0].data = data.all.data || [];
                        this.tabList[0].total_unread = data.all.total_unread || 0;
                        this.tabList[1].data = data.unread.data || [];
                        this.tabList[1].total_unread = data.unread.total_unread || 0;
                        this.tabList[2].data = data.disturb.data || [];
                        this.tabList[2].total_unread = data.disturb.total_unread || 0;
                        this.tabList[2].disturb_unread_count = data.disturb.disturb_unread_count || 0;
                        this.tabList[3].data = data.later.data || [];
                        this.tabList[3].total_unread = data.later.total_unread || 0;
                        this.groupListContent = this.tabList.find((item) => item.state === this.tabActive).data || [];
                        this.category_name_en = this.groupListContent[0]?.category_name_en || "";
                        this.category_icon = this.groupListContent[0]?.icon_url || "";
                        this.$nextTick(() => {
                            this.initCategoryMessages();
                        });
                    }
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        // 静默更新消息数据
        updateMessageGroupCounts() {
            MessageGroupCounts().then((res) => {
                if (res.code === 200) {
                    const data = res.data;
                    this.tabList[0].data = data.all.data || [];
                    this.tabList[0].total_unread = data.all.total_unread || 0;
                    this.tabList[1].data = data.unread.data || [];
                    this.tabList[1].total_unread = data.unread.total_unread || 0;
                    this.tabList[2].data = data.disturb.data || [];
                    this.tabList[2].total_unread = data.disturb.total_unread || 0;
                    this.tabList[2].disturb_unread_count = data.disturb.disturb_unread_count || 0;
                    this.tabList[3].data = data.later.data || [];
                    this.tabList[3].total_unread = data.later.total_unread || 0;
                    this.groupListContent = this.tabList.find((item) => item.state === this.tabActive).data || [];
                }
            });
        },
        // 初始化消息列表数据
        initCategoryMessages() {
            this.messageList = [];
            this.start_id = "";
            this.end_id = "";
            this.orderType = "desc";
            this.finishedList = false;
            this.pullFinishedList = false;
            this.$nextTick(() => {
                this.getCategoryMessages();
            });
        },
        onPullRefreshList() {
            // console.log("下拉");
            if (!this.category_name_en) return;
            this.start_id = this.messageList.length ? this.messageList[0].id : "";
            this.end_id = "";
            this.orderType = "desc";
            // this.finishedList = false;
            // console.log(this.start_id, 'start_id')
            this.getCategoryMessages();
        },
        onLoadList() {
            // console.log("上拉");
            if (!this.category_name_en) return;
            this.start_id = "";
            this.end_id = this.messageList.length ? this.messageList[this.messageList.length - 1].id : "";
            this.orderType = "asc";
            this.getCategoryMessages();
        },
        // 获取消息列表
        getCategoryMessages() {
            if (!this.category_name_en) return;
            // 已经是最顶端的数据，或是最底部的数据了，再加载也没有数据了
            if ((this.finishedList && this.end_id) || (this.pullFinishedList && this.start_id)) return;
            if (this.end_id) {
                this.finishedList = true;
            }
            if (this.start_id) {
                this.pullFinishedList = true;
            }
            this.messageListLoading = true;
            let params = {
                group_type: this.tabActive,
                category_name_en: this.category_name_en,
                order: this.orderType,
                limit: 20,
            };
            if (this.start_id || this.end_id) {
                params.start_id = this.start_id || this.end_id;
            }
            CategoryMessages(params)
                .then((res) => {
                    if (res.code === 200) {
                        const { list_data, show_count_data, min_id } = res.data;
                        if (!this.start_id && !this.end_id) {
                            // 刚初始化数据的时候是没有开始和结束id的
                            const data = list_data.reverse();
                            this.messageList = data;
                            // 只有切换分类刚初始化数据的时候需要将页面滚动到底部
                            this.initContainerToBottom();
                        } else {
                            if (this.orderType == "desc") {
                                // 降序排列
                                // 往上滑动
                                const data = list_data.reverse();
                                this.messageList = data.concat(this.messageList);
                            } else {
                                this.messageList = this.messageList.concat(data);
                            }
                        }
                        // 在未读的消息列表里展示滚动到顶部的图标
                        if (this.tabActive == "unread" && show_count_data > 5) {
                            // 先写死一个数，用于判断一屏幕显示的条数，如果大于这个条数页面才需要展示消息图标
                            this.messageListCount = show_count_data;
                            this.scrollIconMinId = min_id;
                        } else {
                            this.messageListCount = 0;
                            this.scrollIconMinId = "";
                        }
                        // this.pullLoading = this.messageListLoading = false; // 加载和下拉状态结束
                        if (this.end_id || (!this.start_id && !this.end_id)) {
                            this.finishedList = list_data.length === 0; //上滑列表加载完了所有数据（没有更多了）
                        }
                        if (this.start_id) {
                            this.pullFinishedList = list_data.length === 0; //下拉列表加载完了所有数据（没有更多了）
                            if (list_data.length === 0) {
                                this.messageListCount = 0;
                            }
                        }
                    }
                    this.messageListLoading = false;
                })
                .catch(() => {
                    this.messageListLoading = false;
                });
        },
        // 跳转链接
        handleClickToLink(item) {
            const menus = this.routes[this.routes.length - 1]?.children || [];
            const link_data = item.link.split("?")
            const path = link_data[0]
            const currentRoute = menus.find(menuItem=> menuItem.path === path)
            if(currentRoute) {
                // 如果必须在跳转的时候加标签，那么就需要根据name跳转，因为用path跳转的话，传不了params参数了
                const query_arr = link_data[1] ? link_data[1].split('&') : []
                let query_data = {}
                query_arr.forEach(query_item=> {
                    const query_item_arr = query_item.split("=")
                    query_data[query_item_arr[0]] = query_item_arr[1]
                })
                this.$router.push({
                    name: currentRoute.name,
                    params: {
                        isPush: true,
                    },
                    query: query_data,
                })
            } else {
                this.$router.push({
                    params: {
                        isPush: true,
                    },
                    path: item.link,
                })
            }
        }
    },
    beforeDestroy() {
        //销毁前取消监听
        this.observer && this.observer.disconnect();
    },
};
</script>
<style lang="scss" scoped>
@import "@/styles/message.scss";
</style>
<style lang="scss">
.tooltip_text {
    max-width: 728px;
}
</style>
